/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'

export const isAgeRestricted = (t: Listable | Pin | Property) =>
  t.features?.includes(PropertyFeatures.SENIOR_LIVING)
